import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_PROVIDER_SPECIALTY,
  CREATE_PROVIDER_SPECIALTY,
  UPDATE_PROVIDER_SPECIALTY,
  DELETE_PROVIDER_SPECIALTY,
  GET_PROVIDER_SPECIALTY_BY_ID,
} from './actionType';

import {
  ProviderSpecialtyApiResponseSuccess,
  ProviderSpecialtyApiResponseError,
} from './action';

import {
  getProviderSpecialty as specialtyProviderGet,
  getProviderSpecialtyById as specialtyProviderGetById,
  createProviderSpecialty as specialtyProviderCreate,
  updateProviderSpecialty as specialtyProviderUpdate,
  deleteProviderSpecialty as specialtyProviderDelete,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getProviderSpecialty({ payload }) {
  try {
    const response = yield call(specialtyProviderGet, payload.id);
    yield put(
      ProviderSpecialtyApiResponseSuccess(GET_PROVIDER_SPECIALTY, response)
    );
  } catch (error) {
    yield put(ProviderSpecialtyApiResponseError(GET_PROVIDER_SPECIALTY, error));
  }
}

function* getProviderSpecialtyById({ payload }) {
  try {
    const response = yield call(specialtyProviderGetById, payload.id);
    yield put(
      ProviderSpecialtyApiResponseSuccess(
        GET_PROVIDER_SPECIALTY_BY_ID,
        response
      )
    );
  } catch (error) {
    yield put(
      ProviderSpecialtyApiResponseError(GET_PROVIDER_SPECIALTY_BY_ID, error)
    );
  }
}

function* createProviderSpecialty({ payload }) {
  try {
    const response = yield call(specialtyProviderCreate, payload.data);
    yield put(
      ProviderSpecialtyApiResponseSuccess(CREATE_PROVIDER_SPECIALTY, response)
    );
    // notifySuccess(response.message);
  } catch (error) {
    const response = yield put(
      ProviderSpecialtyApiResponseError(CREATE_PROVIDER_SPECIALTY, error)
    );
    notifyError(response.payload.error.response.data.message);
  }
}

function* updateProviderSpecialty({ payload }) {
  try {
    const response = yield call(specialtyProviderUpdate, {
      id: payload.id,
      data: payload.data,
    });
    yield put(
      ProviderSpecialtyApiResponseSuccess(UPDATE_PROVIDER_SPECIALTY, response)
    );
    notifySuccess(response.message);
  } catch (error) {
    const response = yield put(
      ProviderSpecialtyApiResponseError(UPDATE_PROVIDER_SPECIALTY, error)
    );
    notifyError(response.payload.error.response.data.message);
  }
}

function* deleteProviderSpecialty(data) {
  try {
    const response = yield call(specialtyProviderDelete, data.payload.id);
    yield put(
      ProviderSpecialtyApiResponseSuccess(DELETE_PROVIDER_SPECIALTY, response)
    );
    notifySuccess('Especialidade deletada com sucesso!');
  } catch (error) {
    yield put(
      ProviderSpecialtyApiResponseError(DELETE_PROVIDER_SPECIALTY, error)
    );
    notifyError('Erro ao deletar especialidade!');
  }
}

export function* watchGetProviderSpecialty() {
  yield takeEvery(GET_PROVIDER_SPECIALTY, getProviderSpecialty);
}

export function* watchGetProviderSpecialtyById() {
  yield takeEvery(GET_PROVIDER_SPECIALTY_BY_ID, getProviderSpecialtyById);
}

export function* watchCreateProviderSpecialty() {
  yield takeEvery(CREATE_PROVIDER_SPECIALTY, createProviderSpecialty);
}

export function* watchUpdateProviderSpecialty() {
  yield takeEvery(UPDATE_PROVIDER_SPECIALTY, updateProviderSpecialty);
}

export function* watchDeleteProviderSpecialty() {
  yield takeEvery(DELETE_PROVIDER_SPECIALTY, deleteProviderSpecialty);
}

function* ProviderSpecialtySaga() {
  yield all([fork(watchGetProviderSpecialty)]);
  yield all([fork(watchGetProviderSpecialtyById)]);
  yield all([fork(watchCreateProviderSpecialty)]);
  yield all([fork(watchUpdateProviderSpecialty)]);
  yield all([fork(watchDeleteProviderSpecialty)]);
}

export default ProviderSpecialtySaga;
